"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__ICONNAMES__ = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _icons = _interopRequireDefault(require("./icons.json"));

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: ", ";\n  path {\n    fill: ", ";\n  }\n  ellipse {\n    fill: ", ";\n  }\n  :last-child {\n    margin-right: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  if (props.color === 'currentColor') {
    return props.color;
  }

  var icon = _icons["default"][props.name] || _icons["default"].help;
  var color = icon.color || _tokens.baseColors[props.color] || (0, _versions.getColor)(props, 'icon')["default"];
  return color;
};

var Icon = function Icon(props) {
  var icon = _icons["default"][props.name] || _icons["default"].help; // const color = icon.color || (baseColors[props.color] || getColor(props, 'icon').default)

  return _react["default"].createElement(Icon.Element, {
    width: props.size,
    height: props.size,
    viewBox: icon.viewBox || "0 0 ".concat(icon.width, " ").concat(icon.height),
    color: color(props),
    dangerouslySetInnerHTML: icon.html && {
      __html: icon.html
    }
  }, icon.paths && icon.paths.map(function (path, index) {
    return _react["default"].createElement("path", {
      key: index,
      d: path
    });
  }));
};

Icon.Element = _styledComponents["default"].svg(_templateObject(), _tokens.spacing.xxsmall, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var __ICONNAMES__ = Object.keys(_icons["default"]);

exports.__ICONNAMES__ = __ICONNAMES__;
Icon.propTypes = {
  /** Icon name */
  name: _propTypes["default"].oneOf(__ICONNAMES__).isRequired,

  /** Icon size */
  size: _propTypes["default"].number,

  /** Icon foreground color */
  color: _propTypes["default"].string
};
Icon.defaultProps = {
  size: 20,
  color: '#404040'
};
Icon.displayName = 'Icon';

var _default = (0, _context.withVersion)(Icon);

exports["default"] = _default;